import script from "./SawitBuahTable.vue?vue&type=script&setup=true&lang=js"
export * from "./SawitBuahTable.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__